import React from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import AButton from "../../../../../views/pages/manage/common/form-fields-mui/AButton";
import { CourseDetailsPopupById } from "views/pages/manage/unAssigned/studentCharges/common";
import { getFormattedDate } from "../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { AiOutlineEye } from "react-icons/ai";
const ACTION_MESSAGE_MAP = {
  CANCEL:
    "Cheque cancellation for this cheque number will update the status for all associated receipts linked to this cheque.",

  BOUNCE:
    "Cheque bounce for this cheque number will update the status for all associated receipts linked to this cheque.",

  DATE_EXTENSION:
    "Cheque date extension for this cheque number will update the cheque date for all associated receipts linked to this cheque.",

  REVOKE:
    "Cheque revoke action will update the approval status for all associated receipts linked to this cheque.",
};
const UpdateChequeStatusPreCheckModal = ({
  receipts = [],
  onProceed,
  onClose,
  actionType,
}) => {
  // in case of bounce filter cancelled receipts
  const filteredReceipts =
    actionType === "BOUNCE"
      ? receipts.filter((item) => item.status !== "CANCELLED")
      : receipts;
  return (
    <Box>
      <Typography variant="body2" mb={2}>
        {ACTION_MESSAGE_MAP[actionType]}
      </Typography>

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <b>Receipt Number</b>
            </TableCell>
            <TableCell>
              <b>Course ID</b>
            </TableCell>
            <TableCell>
              <b>Cheque Date</b>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {filteredReceipts.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.receiptNo}</TableCell>
              <TableCell>
                {item.courseId}
                <CourseDetailsPopupById
                  courseId={item.courseId}
                  placement="left-end"
                  cta={<AiOutlineEye className="ml-2" />}
                />
              </TableCell>
              <TableCell>{getFormattedDate(item.paymodeDate)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
        <AButton variant="outline" onClick={onClose}>
          Cancel
        </AButton>

        <AButton variant="primary_filled" onClick={onProceed}>
          Proceed
        </AButton>
      </Box>
    </Box>
  );
};

export default UpdateChequeStatusPreCheckModal;
